import { Component } from "react"; 
import { Col, Container, Row } from "reactstrap";
import NavTab from "../../../components/common/global_layout/navTab";
import AdvancedSearchVoyage from "../../../components/common/Voyages/advancedSearchVoyage";

class Offres_hajj extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return (
          <>
            <Container>
              <NavTab display="none" />
              <AdvancedSearchVoyage/>

              <Row className="px-3">
                <Col sm="3"  className="my-2">
                  <img src="/imgs/announces/index.png" className="img_full" alt="" />
                </Col>
                <Col sm="3" className="my-2">
                  <img src="/imgs/announces/index2.png" className="img_full" alt="" />
                </Col>
                <Col sm="3" className="my-2">
                  <img src="/imgs/announces/index5.png" className="img_full" alt="" />
                </Col>
                <Col sm="3" className="my-2">
                  <img src="/imgs/announces/index3.png" className="img_full" alt="" />
                </Col>

                <Col sm="3" className="my-2">
                  <img src="/imgs/announces/index6.png" className="img_full" alt="" />
                </Col>
                <Col sm="3" className="my-2">
                  <img src="/imgs/announces/index2.png" className="img_full" alt="" />
                </Col>
                <Col sm="3" className="my-2">
                  <img src="/imgs/announces/index3.png" className="img_full" alt="" />
                </Col>
                <Col sm="3" className="my-2">
                  <img src="/imgs/announces/index.png" className="img_full" alt="" />
                </Col>
              </Row>
            </Container>
          </>
        );
    }
}
 
export default Offres_hajj;